import { render, staticRenderFns } from "./item-one.vue?vue&type=template&id=023cf3c0&scoped=true&"
import script from "./item-one.vue?vue&type=script&lang=js&"
export * from "./item-one.vue?vue&type=script&lang=js&"
import style0 from "./item-one.vue?vue&type=style&index=0&id=023cf3c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023cf3c0",
  null
  
)

export default component.exports